// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
import "./CSS/LoginPage.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import loginVideoUrls from "../Assets/LogInVideos.json";
import LoginImage from "../Assets/LoginBackground.png";
import Logo from "../Assets/Logo.svg";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "../Components/ui/input-otp";
import crypto from "crypto-js";
import { TIMER_SETTINGS } from "../Services/ConfigurationService";
import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
import config from "../config.json";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setmail,
  setworkspace,
  setWorkspaceId,
  setAdvUrl,
  setAdminUrl,
  setForgotPassword,
  setIsAdmin,
  setSmsUrl,
  setOperatorUrl,
  setRoleId,
  setAuthUrl,
  setisAuthstate,
  setntfyUrl,
  setUserIP,
  setQuickTestUrl,
} from "../State/slices/AuthenticationSlice";
import { RootState } from "../State/store";
import { useToast } from "../Components/ui/use-toast";
import { Toaster } from "../Components/ui/toaster";

import jwt_decode, { jwtDecode, JwtPayload } from "jwt-decode"; // Replacing jsonwebtoken with jwt-decode
import {
  setPermissions,
  setUser_Role_Name,
} from "../State/slices/AdvertiserAccountSlice";

interface DecodedToken {
  Email: string;
  Name: string;
  WorkspaceId: number;
  RoleId: string;
  exp: number;
  iss: string;
  aud: string;
}

interface OTPProps {
  separator?: React.ReactNode;
  length: number;
  value: string;
  onChange: (value: string) => void;
}

function hashOtp(otp: string): string {
  return crypto.SHA256(otp).toString();
}

function OTP({}: OTPProps) {
  const [PageLoad, setPageLoad] = useState<boolean>(false);

  return (
    <>
      {PageLoad && (
        <>
          <p>Loading</p>
          <div className="page-preloader"></div>
        </>
      )}
      {!PageLoad && (
        <Container maxWidth="xs" sx={{ padding: 2, alignItems: "center" }}>
          <Toaster />
          <Box
            component="form"
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "24px",
                color: "#09090B",
              }}
            >
              Verify your email
            </Typography>
            <Typography
              variant="subtitle2"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: 400,
                fontSize: "14px",
                paddingTop: "0.5rem",
              }}
              className="text-gray-500"
            >
              We sent you an email with your one-time password
            </Typography>
          </Box>
        </Container>
      )}
    </>
  );
}

export default function EmailVerificationPage() {
  const dispatch = useDispatch();
  const [timer, setTimer] = useState<number>(TIMER_SETTINGS.INITIAL_TIME);
  const [canResend, setCanResend] = useState<boolean>(false);
  const [value, setValue] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = React.useState("");
  const [Login, setLogin] = React.useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const mail = location.state?.email || location.state?.newEmail || " ";
  const login = location.state?.isLogin || "";

  const [apiUrl, setApiUrl] = useState("");

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const toast = useToast();

  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );

  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const isInvited = useSelector(
    (state: RootState) => state.authentication.isInvited,
  );
  const token = useSelector(
    (state: RootState) => state.authentication.inviteToken.token,
  );
  const reviewData = useSelector(
    (state: RootState) => state.authentication.reviewToken,
  );

  const forgotPassword = useSelector(
    (state: RootState) => state.authentication.forgotPassword,
  );
  const loginVideoMP4 = loginVideoUrls.LoginVideoUrl;
  const loginVideoWebM = loginVideoUrls.LoginVideoUrlWebM;

  console.log("FP:", forgotPassword);

  useEffect(() => {
    if (mail) setEmail(mail);
    if (login) setLogin(login);

    fetch("/config.json")
      .then((response) => response.json())
      .then((config) => {
        setApiUrl(config.API_URL);
        dispatch(setAuthUrl(config.API_URL));
        dispatch(setAdvUrl(config.ApiUrlAdvAcc));
        dispatch(setAdminUrl(config.ApiUrlAdminAcc));
        dispatch(setSmsUrl(config.SmsUrlAdminAcc));
        dispatch(setOperatorUrl(config.OperatorUrl));
        dispatch(setntfyUrl(config.NtfyUrl));
        dispatch(setQuickTestUrl(config.QuickTestUrl));
      })
      .catch((error) => {
        console.error("Error loading config:", error);
        toast.toast({
          title: "Error",
          description: "Something went wrong, please try again.",
        });
      });
  }, []);

  useEffect(() => {
    if (timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(intervalRef.current!);
            setCanResend(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    } else {
      setCanResend(true);
    }

    return () => {
      clearInterval(intervalRef.current!);
    };
  }, [timer]);

  // const setSessionDataWithExpiry = (key: string, value: any, expiryInMinutes: number) => {
  //     const now = new Date().getTime();
  //     const item = {
  //         value: value,
  //         expiry: now + expiryInMinutes * 60 * 1000, // Convert minutes to milliseconds
  //     };
  //     sessionStorage.setItem(key, JSON.stringify(iteccm));
  // };

  //   const handleSubmit = async (email: string, otp: string) => {
  //     if (timer <= 0) {
  //       toast.toast({
  //         title: "Time Expired",
  //         description: "Time expired. Please click Resend OTP.",
  //       });
  //       setValue("");
  //       return;
  //     }

  //     let ipAddress = "";
  //     try {
  //       const trackRes = await axios.post(`${apiUrl}/TrackVisit`);
  //       ipAddress = trackRes.data.ip;
  //       localStorage.setItem("UserIP", ipAddress);
  //       dispatch(setUserIP(ipAddress));
  //     } catch (trackErr) {
  //       console.error("Error calling track API:", trackErr);
  //     }
  //     setIsLoading(true);

  //     let auditData: any = {};

  // try {
  //       const response = await axios.post(`${apiUrl}/VerifyOtp`, {
  //         Email: email,
  //         Otp: otp,
  //       });

  //       if (response.status === 200 && response.data.status === 'Success') {
  //                 let decodedWorkspaceId = 0;
  //         const isLoginFlow = Login === 'Login' && !forgotPassword;

  //         if (response.data?.token != null) {
  //           const token = response.data?.token;

  //           if (isLoginFlow) {
  //             const isLocalhost = window.location.hostname === 'localhost';

  //             document.cookie = `AuthToken=${token}; path=/; max-age=${10 * 60 * 60
  //               }; ${isLocalhost ? 'SameSite=Lax' : 'SameSite=None; Secure'}`;
  //             axios.defaults.withCredentials = true;

  //             try {
  //               const decoded = jwtDecode<DecodedToken>(token);
  //               decodedWorkspaceId = decoded.WorkspaceId || 0;

  //               // update Redux + session
  //               dispatch(setWorkspaceId(decodedWorkspaceId));
  //               sessionStorage.setItem(
  //                 'workspace_id',
  //                 decodedWorkspaceId.toString()
  //               );

  //               console.log('Decoded WorkspaceId:', decodedWorkspaceId);
  //             } catch (decodeError) {
  //               console.error('Error decoding token:', decodeError);
  //             }
  //           } else {
  //             sessionStorage.setItem('ResetToken', token);
  //           }
  //         }

  //         if (isLoginFlow) {
  //           dispatch(setisAuthstate(true));
  //           sessionStorage.setItem('otpVerified', 'true');
  //           sessionStorage.setItem('email', email);
  //         } else {
  //           // Make sure we don't accidentally mark the user as verified/authenticated
  //           sessionStorage.removeItem('otpVerified');
  //         }

  //         // Track IP
  //         let ipAddress = '';
  //         try {
  //           const trackRes = await axios.post(`${apiUrl}/TrackVisit`);
  //           ipAddress = trackRes.data.ip;
  //           localStorage.setItem('UserIP', ipAddress);
  //           dispatch(setUserIP(ipAddress));
  //         } catch (trackErr) {
  //           console.error('Error calling track API:', trackErr);
  //         }

  //         // ✅ Create auditData with the fetched workspace_id
  //         auditData = {
  //           UserAccountId: accountId,
  //           CampaignId: 0,
  //           AdvertiserWorkspaceId: 0,
  //           Action: 'OTP Verification',
  //           ActionPage: 'OTP Verification Page',
  //           Status: 'Success',

  //           // AfterData: JSON.stringify({
  //           //   otpVerified: true,
  //           //   email,
  //           //   Message: 'Logged in successfully',
  //           // }),
  //           AfterData: JSON.stringify({
  //             otpVerified: true,
  //             email,
  //             Message: Login === 'Login' ? 'Logged in successfully' : 'OTP Verified successfully',
  //           }),

  //           Comments: 'OTP verification action',
  //         };

  //         // ✅ Insert audit log BEFORE handlePostOTP
  //         try {
  //           console.log(
  //             'Inserting audit log with WorkspaceId:',
  //             auditData.AdvertiserWorkspaceId
  //           );
  //           await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
  //         } catch (error) {
  //           console.error('Error inserting audit log:', error);
  //         }

  //         // Now continue with the rest of the flow
  //         await handlePostOTP(email);

  //         toast.toast({
  //           title: 'Success',
  //           description: 'OTP verified successfully',
  //         });
  //       } else {
  //         auditData = {
  //           UserAccountId: accountId,
  //           CampaignId: null,
  //           AdvertiserWorkspaceId: 0,
  //           Action: 'OTP Verification',
  //           ActionPage: 'OTP Verification Page',
  //           Status: 'Failure',
  //           BeforeData: JSON.stringify({ email }),
  //           AfterData: JSON.stringify({ otpVerified: false, email }),
  //           IpAddress: '',
  //           Comments: 'OTP verification failed',
  //         };

  //         try {
  //           await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
  //         } catch (error) {
  //           console.error('Error inserting audit log:', error);
  //         }

  //         handleOTPError();
  //       }
  //     } catch (error) {
  //       console.error("Error during OTP verification:", error);

  //       auditData = {
  //         UserAccountId: accountId,
  //         CampaignId: null,
  //         AdvertiserWorkspaceId: 0,
  //         Action: "OTP Verification",
  //         ActionPage: "OTP Verification Page",
  //         Status: "Failure",
  //         BeforeData: JSON.stringify({ email }),
  //         AfterData: JSON.stringify({ otpVerified: false, email }),
  //         IpAddress: "",
  //         Comments: "OTP verification error",
  //       };

  //       try {
  //         await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
  //       } catch (error) {
  //         console.error("Error inserting audit log:", error);
  //       }

  //       toast.toast({
  //         title: "Error",
  //         description: "An error occurred, please try again.",
  //       });
  //       setValue("");
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const handleSubmit = async (email: string, otp: string) => {
    if (timer <= 0) {
      toast.toast({
        title: "Time Expired",
        description: "Time expired. Please click Resend OTP.",
      });
      setValue("");
      return;
    }

    setIsLoading(true);

    // ✅ Track IP FIRST - before any OTP verification
    let ipAddress = "";
    try {
      const trackRes = await axios.post(`${apiUrl}/TrackVisit`);
      ipAddress = trackRes.data.ip;
      localStorage.setItem("UserIP", ipAddress);
      dispatch(setUserIP(ipAddress));
      console.log("IP Address captured:", ipAddress);
    } catch (trackErr) {
      console.error("Error calling track API:", trackErr);
    }

    let auditData: any = {};

    try {
      const response = await axios.post(`${apiUrl}/VerifyOtp`, {
        Email: email,
        Otp: otp,
      });

      if (response.status === 200 && response.data.status === "Success") {
        let fetchedWorkspaceId = 0;

        // ✅ Determine the flow type
        const isLoginFlow = Login === "Login" && !forgotPassword;
        const isForgotPasswordFlow = forgotPassword;

        // ✅ Handle token for Login and Signup (NOT for forgot password)
        if (response.data?.token != null) {
          const token = response.data?.token;

          if (isForgotPasswordFlow) {
            // For forgot password, store in session for password reset page
            sessionStorage.setItem("ResetToken", token);
          } else {
            // For Login and Signup, set auth cookie
            const isLocalhost = window.location.hostname === "localhost";

            document.cookie = `AuthToken=${token}; path=/; max-age=${10 * 60 * 60}; ${
              isLocalhost ? "SameSite=Lax" : "SameSite=None; Secure"
            }`;
            axios.defaults.withCredentials = true;

            // Set authentication state for both Login and Signup
            dispatch(setisAuthstate(true));
            sessionStorage.setItem("otpVerified", "true");
            sessionStorage.setItem("email", email);
          }
        }

        // ✅ Fetch workspace_id for Login and Signup (NOT for forgot password)
        if (!isForgotPasswordFlow) {
          try {
            const workspaceResponse = await axios.get(
              `${apiUrl}/GetWorkspaceNameByEmail?EmailId=${email}`,
            );
            if (
              workspaceResponse.status === 200 &&
              workspaceResponse.data.status === "Success"
            ) {
              fetchedWorkspaceId =
                workspaceResponse.data.workspaceName.workspace_id;

              // Update Redux and sessionStorage
              dispatch(setWorkspaceId(fetchedWorkspaceId));
              sessionStorage.setItem(
                "workspace_id",
                fetchedWorkspaceId.toString(),
              );

              console.log("Fetched WorkspaceId from API:", fetchedWorkspaceId);
            }
          } catch (error) {
            console.error("Error fetching workspace:", error);
          }
        }

        // ✅ Create auditData (IP already captured at the start)
        auditData = {
          UserAccountId: accountId,
          CampaignId: 0,
          AdvertiserWorkspaceId: fetchedWorkspaceId || 0,
          Action: "OTP Verification",
          ActionPage: "OTP Verification Page",
          Status: "Success",
          AfterData: JSON.stringify({
            otpVerified: true,
            email,
            Message: isForgotPasswordFlow
              ? "OTP Verified for Password Reset"
              : isLoginFlow
                ? "Logged in successfully"
                : "Signed up successfully",
          }),
          Comments: "OTP verification action",
        };

        // ✅ Insert audit log
        try {
          console.log(
            "Inserting audit log with WorkspaceId:",
            auditData.AdvertiserWorkspaceId,
          );
          await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
        } catch (error) {
          console.error("Error inserting audit log:", error);
        }

        // ✅ Continue with post-OTP flow
        await handlePostOTP(email);

        toast.toast({
          title: "Success",
          description: isForgotPasswordFlow
            ? "OTP verified. You can now reset your password."
            : "OTP verified successfully",
        });
      } else {
        // ❌ Failure case (IP already captured at the start)
        auditData = {
          UserAccountId: accountId,
          CampaignId: null,
          AdvertiserWorkspaceId: 0,
          Action: "OTP Verification",
          ActionPage: "OTP Verification Page",
          Status: "Failure",
          BeforeData: JSON.stringify({ email }),
          AfterData: JSON.stringify({ otpVerified: false, email }),
          Comments: "OTP verification failed",
        };

        try {
          await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
        } catch (error) {
          console.error("Error inserting audit log:", error);
        }

        handleOTPError();
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);

      // ❌ Error case (IP already captured at the start)
      auditData = {
        UserAccountId: accountId,
        CampaignId: null,
        AdvertiserWorkspaceId: 0,
        Action: "OTP Verification",
        ActionPage: "OTP Verification Page",
        Status: "Failure",
        BeforeData: JSON.stringify({ email }),
        AfterData: JSON.stringify({ otpVerified: false, email }),
        Comments: "OTP verification error",
      };

      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditData);
      } catch (error) {
        console.error("Error inserting audit log:", error);
      }

      toast.toast({
        title: "Error",
        description: "An error occurred, please try again.",
      });
      setValue("");
    } finally {
      setIsLoading(false);
    }
  };

  const getOperatorMappingId = async (
    campaign_id: number,
    operator_id: number,
  ) => {
    try {
      debugger;
      const response = await axios.post(
        `${apiUrl}/GetOperatorMappingId?campaign_id=${campaign_id}&workspace_id=${operator_id}`,
      );
      if (response.data.status === "Success") {
        if (response.data.operatorMappingId !== null) {
          return Number(response.data.operatorMappingId);
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (err) {
      console.error(
        `Error in fetching operator_mapping_id for campaign_id: ${campaign_id}`,
      );
    }
  };

  const handlePostOTP = async (email: string) => {
    if (Login === "Login") {
      try {
        const workspaceResponse = await axios.get(
          `${apiUrl}/GetWorkspaceNameByEmail?EmailId=${email}`,
        );
        if (
          workspaceResponse.status === 200 &&
          workspaceResponse.data.status === "Success"
        ) {
          const { workspace_name, workspace_type, workspace_id } =
            workspaceResponse.data.workspaceName;

          dispatch(setmail(email));
          dispatch(setworkspace(workspace_name));
          dispatch(setWorkspaceId(workspace_id));

          // Store in sessionStorage
          // setSessionDataWithExpiry("workspace_id", workspace_id.toString(), 60);
          sessionStorage.setItem("workspace_id", workspace_id);

          await checkIfAdmin(email);
          await fetchRoleDetails(accountId, workspace_id);
          debugger;
          if (reviewData.action === "admin_review") {
            debugger;
            navigate("/adminNavbar/admincampaignapproval", {
              state: {
                campaignId: reviewData.cid,
                campaignWorkspaceId: reviewData.wid,
              },
            });
          } else if (reviewData.action === "operator_review") {
            debugger;
            const operator_mapping_id = await getOperatorMappingId(
              reviewData.cid,
              workspace_id,
            );
            if (operator_mapping_id !== null) {
              navigate("/operatorNavbar/operatorcampaignapproval", {
                state: {
                  campaignId: reviewData.cid,
                  operatorMappingId: operator_mapping_id,
                },
              });
            } else {
              navigateWithDelay(
                workspace_type === "Telecom Operator"
                  ? "/operatorNavbar/dashboard"
                  : "/navbar/dashboard",
                { state: { path: workspace_name, email, route: "Dashboard" } },
              );
            }
          } else if (reviewData.action === "admin_welcome_review") {
            navigate("/adminNavbar/templates", {
              state: {
                template_id: reviewData.tid,
                workspace_id: reviewData.wid,
                mode: "edit",
              },
            });
          } else if (reviewData.action === "operator_welcome_review") {
            navigate("/operatorNavbar/templatelist", {
              state: {
                templateId: reviewData.tid,
                action: reviewData.action,
                authenticated: true,
              },
            });
          } else if (reviewData.action === "operator_welcome_review") {
            if (reviewData.tid !== 0) {
              navigate("/operatorNavbar/templatelist", {
                state: {
                  templateId: reviewData.tid,
                  action: reviewData.action,
                  authenticated: true,
                },
              });
            }
          } else {
            navigateWithDelay(
              workspace_type === "Telecom Operator"
                ? "/operatorNavbar/dashboard"
                : "/navbar/dashboard",
              { state: { path: workspace_name, email, route: "Dashboard" } },
            );
          }
        }
      } catch (error) {
        console.error("Error fetching workspace:", error);
      }
    } else if (forgotPassword) {
      navigate("/");
    } else {
      await checkIfAdmin(email);
      if (isInvited) {
        await handleInvitation(email);
      }
      navigate("/personalinfo", { state: { path: "", email } });
    }
  };

  const checkIfAdmin = async (email: string) => {
    try {
      const response = await axios.get(
        `${apiUrl}/CheckIfAdmin?EmailId=${email}`,
      );
      if (response.data.status === "Success") {
        dispatch(setIsAdmin(response.data.isAdmin));
      } else {
        console.log("CheckIfAdmin API error");
      }
    } catch (error) {
      console.error("Error checking admin status:", error);
    }
  };

  const fetchRoleDetails = async (accountId: number, workspaceId: number) => {
    try {
      const response = await axios.get(
        `${apiUrl}/GetUserWorkspaceRoleDetails/GetUserWorkspaceRoleDetails?accountId=${accountId}&workspaceId=${workspaceId}`,
      );

      if (response.data.status === "Success") {
        const roleId = response.data.userWorkspaceRoleDetails[0]?.roleId;
        dispatch(setRoleId(roleId));

        // Store accountId in sessionStorage
        // setSessionDataWithExpiry("accountId", accountId.toString(), 60);
        sessionStorage.setItem("accountId", accountId.toString());

        if (roleId) {
          await fetchPermissions(roleId);
        }
      } else {
        console.log("GetUserWorkspaceRoleDetails API error");
      }
    } catch (error) {
      console.error("Error fetching user workspace role details:", error);
    }
  };

  const fetchPermissions = async (roleId: string) => {
    try {
      const response = await axios.get(
        `${apiUrl}/GetPermissionsByRoleId?RoleID=${roleId}`,
      );
      if (response.data.status === "Success") {
        const permissions = JSON.parse(response.data.roleDetails.permissions);
        const role_name = response.data.roleDetails.roleName;
        dispatch(setPermissions(permissions));
        dispatch(setUser_Role_Name(role_name));
      } else {
        console.log("GetPermissionsByRoleId API error");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleInvitation = async (email: string) => {
    try {
      const decoded = jwtDecode<DecodedToken>(token);
      const workspaceId = decoded.WorkspaceId;
      dispatch(setWorkspaceId(workspaceId));
      navigate("/personalinfo", { state: { path: "", email } });
    } catch (error) {
      console.error("Error handling invitation:", error);
      toast.toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
      });
    }
  };

  const navigateWithDelay = (path: string, state: any) => {
    setTimeout(() => {
      navigate(path, state);
    }, 2000);
  };

  const handleOTPError = () => {
    console.log("Invalid OTP Response");
    toast.toast({
      title: "Error",
      description: "Invalid OTP. Please try again or wait to resend.",
    });
    setValue("");
  };

  const otpInputRef = useRef<HTMLInputElement>(null); // Specify the input element type

  const handleResendOTP = async (email: string) => {
    setIsLoading(true);
    if (otpInputRef.current) {
      otpInputRef.current.focus(); // Set focus to the first OTP input
    }

    try {
      const response = await axios.post(`${apiUrl}/SendOtp/SendOtp`, {
        Email: email,
      });

      if (response.status === 200 && response.data.status === "Success") {
        setTimer(TIMER_SETTINGS.INITIAL_TIME); // Reset the timer
        setCanResend(false); // Disable the Resend OTP button again
        toast.toast({
          title: "Success",
          description: response.data.message,
        });
      } else {
        toast.toast({
          title: "Error",
          description: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.toast({
        title: "Error",
        description: "An error occurred, please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const formatTimer = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div
      className="email-verification-page"
      style={{ display: "flex", height: "100vh", overflow: "hidden" }}
    >
      <Toaster />
      {isLoading && (
        <div className="loading-overlay">
          <CircularProgress color="primary" />
        </div>
      )}
      <div
        style={{
          position: "fixed",
          top: "30px",
          left: "30px",
          zIndex: 20,
        }}
      >
        <img src={Logo} alt="Logo" style={{ width: "170px", height: "auto" }} />
      </div>
      <div
        className="left-pane"
        style={{
          flex: "2.2",
          // backgroundImage: `url(${figmaPageImage})`,
          // backgroundSize: 'cover',
          backgroundPosition: "center",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="background-video"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "fill",
          }}
        >
          <source src={loginVideoWebM} type="video/webm" />
          <source src={loginVideoMP4} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Right pane without any structural or alignment changes */}
      <div
        className="right-pane"
        style={{
          flex: "1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="LoginMatCard"
          style={{ width: "90%", maxWidth: "400px", marginTop: "12px" }}
        >
          <OTP length={0} value={""} onChange={() => {}} />
          <InputOTP
            ref={otpInputRef} // Assign the ref to the first input
            maxLength={6}
            value={value}
            onChange={(value) => {
              setValue(value);
              if (value.length === 6) {
                const hashedOtp = hashOtp(value);
                handleSubmit(email, hashedOtp);
              }
            }}
            autoFocus
          >
            <InputOTPGroup>
              <InputOTPSlot index={0} className="border border-[#E2E8F0]" />
              <InputOTPSlot index={1} className="border border-[#E2E8F0]" />
              <InputOTPSlot index={2} className="border border-[#E2E8F0]" />
            </InputOTPGroup>
            <InputOTPSeparator />
            <InputOTPGroup>
              <InputOTPSlot index={3} className="border border-[#E2E8F0]" />
              <InputOTPSlot index={4} className="border border-[#E2E8F0]" />
              <InputOTPSlot index={5} className="border border-[#E2E8F0]" />
            </InputOTPGroup>
          </InputOTP>

          <Typography
            variant="subtitle2"
            sx={{
              textAlign: "center",
              marginTop: "10px",
              fontSize: "14px",
              color: "#000000",
              fontWeight: 400,
            }}
          >
            Enter your one-time password
          </Typography>

          <Typography
            variant="body2"
            gutterBottom
            sx={{
              textAlign: "center",
              color: "#AEAEAE",
              cursor: "pointer",
              marginTop: "30px",
            }}
          >
            {canResend ? (
              <Button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  textTransform: "capitalize",
                }}
                onClick={() => handleResendOTP(email)}
              >
                Resend OTP
              </Button>
            ) : (
              `Resend OTP in ${formatTimer(timer)}`
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
}
